import { LocalStorageKeys } from "../constants/localStorageKeys.enum";
export class ConsoleLogger {
    static logInfo(message?: any, ...optionalParams: any[]) {
        const infoEnabledLsValue = localStorage.getItem(LocalStorageKeys.CONSOLE_LOG_INFO_ENABLED);
        const infoEnabled = infoEnabledLsValue && infoEnabledLsValue === 'true';
        const traceEnabledLsValue = localStorage.getItem(LocalStorageKeys.CONSOLE_LOG_INCLUDE_TRACE);
        const traceEnabled = traceEnabledLsValue && traceEnabledLsValue === 'true';

        if (!infoEnabled) {
            return;
        }

        if (optionalParams.length > 0) {
            if (traceEnabled) {
                // This utility is the app's logging path; emitting a stack trace is its
                // purpose here, and it is reached only when the operator opts in via the
                // CONSOLE_LOG_INCLUDE_TRACE local-storage flag.
                /* tslint:disable-next-line:no-console */
                console.trace(message, optionalParams);
            } else {
                console.log(message, optionalParams);
            }
        } else {
            if (traceEnabled) {
                // Same opt-in trace path as above, for the no-optionalParams case.
                /* tslint:disable-next-line:no-console */
                console.trace(message);
            } else {
                console.log(message);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/core/utilities/console-logger.ts